import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import { Flex } from 'core/ui/atoms';
import { Button } from 'johari/ui/atoms';
import BG_IMAGE from 'johari/assets/bg.jpg';
// import LOGO_IMAGE from "johari/assets/mcrcsm_logo.png";
// import NEW_LOGO_IMAGE from "johari/assets/logo_square.png";

class JohariLayout extends PureComponent {
  static propTypes = {
    children: PropTypes.node.isRequired,
    nextSlide: PropTypes.func,
    showNextButton: PropTypes.bool,
    disableNextButton: PropTypes.bool,
    setHidden: PropTypes.bool,
    t: PropTypes.func,
    currentSlide: PropTypes.number,
  };

  buttonRef = React.createRef();

  scrollToButton = () => {
    this.buttonRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  render() {
    const { showNextButton, disableNextButton, setHidden, currentSlide, t } =
      this.props;
    return (
      <>
        <Wrapper id="wrapper" direction={'column'} alignItems={'stretch'}>
          {/* <LogoCont>
            <img src={NEW_LOGO_IMAGE} width={130} />
          </LogoCont> */}
          <Container>
            <Flex
              direction={'column'}
              alignItems={'center'}
              style={{ overflow: setHidden ? 'hidden' : 'none' }}
            >
              {typeof this.props.children === 'function'
                ? this.props.children(this.scrollToButton)
                : this.props.children}
            </Flex>
            {showNextButton ? (
              <>
                <Button
                  ref={this.buttonRef}
                  onClick={disableNextButton ? undefined : this.props.nextSlide}
                  style={{ marginTop: 45 }}
                  disabled={disableNextButton}
                >
                  {currentSlide ? t('next') : t('start')}
                </Button>
                {!currentSlide && <Disclaimer>{t('shortTestDesc')}</Disclaimer>}
              </>
            ) : null}
          </Container>
        </Wrapper>
      </>
    );
  }
}

const Wrapper = styled.div`
  min-height: 100vh;
  padding: 60px;
  overflow-y: scroll;
  ${p => p.theme.max('sm')`
    padding: 40px;
    max-height: 100vh;
    justify-content: space-between;
  `};
`;

const Container = styled(Flex)`
  position: relative;
  z-index: 2;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${p => p.theme.max('sm')`
    overflow: ${p.setHidden ? 'hidden' : 'none'};
    justify-content: space-between;
  `};
`;

const Disclaimer = styled.p`
  color: ${p => p.theme.colors.gray.regular};
  font-size: 16px;
`;

const LogoCont = styled(Flex).attrs({
  justifyContent: 'center',
})`
  position: relative;
  z-index: 2;
  flex-grow: 0;
  flex-shrink: 0;
  margin-top: -20px;
  margin-bottom: -10px;
  ${p => p.theme.max('sm')`
    margin-bottom: 10px;
  `};
`;

const MobileWrapper = styled(Flex)`
  min-height: 100vh;
  padding: 40px;
  background: url(${BG_IMAGE});
  background-size: cover;
  max-height: 100vh;
`;

export default withTranslation()(JohariLayout);
